export default __webpack_public_path__ + "static/media/Ring of Dagon.4197af5f.jpg";